import React, { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { Button } from "../../../../shared/ui";

export interface DeclineTransferModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isSubmitting?: boolean;
}

export const DeclineTransferModal: React.FC<DeclineTransferModalProps> = ({
  open,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  const [reason, setReason] = useState("");
  const maxLen = 100;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (reason.trim()) {
      onConfirm(reason.trim());
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-xs transition-opacity" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white p-6 shadow-xl focus:outline-hidden">
          {/* Header */}
          <div className="flex items-start justify-between">
            <div className="flex flex-col gap-1">
              <Dialog.Title className="text-[18px] font-semibold text-[#101828]">
                Decline OTC transfer request
              </Dialog.Title>
              <Dialog.Description className="text-[13px] text-[#667085]">
                Why are you declining this request?
              </Dialog.Description>
            </div>
            <Dialog.Close asChild>
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg p-1 text-[#98A2B3] transition-colors hover:bg-[#F2F4F7] hover:text-[#344054]"
                aria-label="Close"
              >
                <X size={20} />
              </button>
            </Dialog.Close>
          </div>

          <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
            <div className="relative">
              <textarea
                rows={4}
                maxLength={maxLen}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter a reason"
                className="w-full resize-none rounded-[8px] border border-transparent bg-[#F8F9FC] p-3.5 pb-7 text-[14px] text-[#101828] placeholder-[#98A2B3] focus:border-[#D92D20] focus:bg-white focus:outline-hidden"
              />
              <span className="absolute bottom-2.5 right-3 text-[11px] text-[#98A2B3]">
                {reason.length}/{maxLen}
              </span>
            </div>

            {/* Actions */}
            <div className="mt-2 flex justify-end">
              <Button
                type="submit"
                disabled={!reason.trim() || isSubmitting}
                className="h-10 rounded-[8px] bg-[#D92D20] px-6 text-[14px] font-medium text-white shadow-xs transition-colors hover:bg-[#B42318] disabled:bg-[#90A1B9] disabled:text-white disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Declining..." : "Decline"}
              </Button>
            </div>
          </form>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
